module.exports = __webpack_public_path__ + "img/30.26e81403.jpg";